import { render } from "./Laporan8A.vue?vue&type=template&id=2c18188e"
import script from "./Laporan8A.vue?vue&type=script&lang=js"
export * from "./Laporan8A.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__